import { InputAsyncSelect, InputSelectControl } from '../../Select'
import { getPostMessageTemplates } from '../Post.api'
import { toPostMessageTemplateSelectItems } from '../Post.utils'

import {
  POST_MESSAGE_TEMPLATE_SELECT_API_PARAMS,
  POST_MESSAGE_TEMPLATE_SELECT_DROPDOWN_FLOATING_CONFIG,
} from './PostMessageTemplateSelect.constants'
import { getPostMessageTemplateSelectDataItems } from './PostMessageTemplateSelect.utils'

function PostMessageTemplateSelect({
  Control = InputSelectControl,
  apiParams = POST_MESSAGE_TEMPLATE_SELECT_API_PARAMS,
  dropdownFloatingConfig = POST_MESSAGE_TEMPLATE_SELECT_DROPDOWN_FLOATING_CONFIG,
  getData = getPostMessageTemplates,
  getDataItems = getPostMessageTemplateSelectDataItems,
  toPreparedItems = toPostMessageTemplateSelectItems,
  ...restProps
}) {
  return (
    <InputAsyncSelect
      {...restProps}
      Control={Control}
      apiParams={apiParams}
      dropdownFloatingConfig={dropdownFloatingConfig}
      getData={getData}
      getDataItems={getDataItems}
      toPreparedItems={toPreparedItems}
    />
  )
}

export default PostMessageTemplateSelect
